<script setup lang="ts">
import {
  $getWaitingRoomItemOptions,
  type WaitingRoomFile,
} from '@/api/fileManagement'

interface Props {
  modelValue: boolean
  file: WaitingRoomFile | null
  loading?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  loading: false,
})

interface Emit {
  (e: 'update:modelValue', value: boolean): void
  (e: 'save', value: string): void
}

const emit = defineEmits<Emit>()

const isVisible = computed({
  get: () => props.modelValue,
  set: value => emit('update:modelValue', value),
})

const initialFilename = computed(() => props.file?.new_filename || props.file?.name || '')

const loadOptions = (params: { search: string; page: number; per_page: number }) => {
  return $getWaitingRoomItemOptions({
    waiting_room_file_id: props.file?.id,
    search: params.search,
    page: params.page,
    per_page: params.per_page,
  })
}
</script>

<template>
  <ProjectFilesRenameDialog
    v-model="isVisible"
    :initial-filename="initialFilename"
    :extension="file?.extension || ''"
    :loading="loading"
    :request-key="file?.id || null"
    :load-options="loadOptions"
    load-initial-options-without-search
    @save="emit('save', $event)"
  />
</template>
